<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormStockItem
      :StockItem="editStockItem"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormStockItem from '../components/FormStockItem.vue';

export default {
  components: {
    FormStockItem,
  },
  name: 'EditStockItem',
  module: 'StockItem',
  mixins: [loading],
  data() {
    return {
      /**
      * Get/Set editing StockItem. Default to {}.
      */
      editStockItem: {},
      /**
       * Query Id for StockItem
       */
      stockItemId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('stockItems', ['stockItems', 'stockItem']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.stockItemId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.isLoading = true;
    if (this.mode === 'edit') {
      await this.LOAD_stockItem(this.stockItemId);
      this.editStockItem = this.stockItem;
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('stockItems', ['LOAD_stockItem', 'CREATE_stockItem', 'UPDATE_stockItem']),
    /** Method used to save the item
     */
    async save(stockItem) {
      const {
        id,
        harvestedMass,
        packedMass,
        quantity,
        sizeRange,
      } = stockItem;
      this.isSaving = true;
      await this.UPDATE_stockItem({
        id,
        harvestedMass,
        packedMass,
        quantity,
        sizeRange,
      });
      this.isSaving = false;
      this.$router.push({ name: 'processing-ListStockItem' });
    },
  },
};
</script>

<docs>
# EditStockItem example

'''js
<EditStockItem :StockItem="StockItem" />
'''
</docs>
